import PropTypes from "prop-types";

// Hooks
import useNotificationEmailPreview from "../../hooks/useNotificationEmailPreview.js";

// Components
import Modal from "../../components/Modal.js";
import NotificationEmailPreview from "./NotificationEmailPreview.js";

// Style
import {Heading} from "../../style/components/general.js";

const previewHeading = preview =>
  preview?.isSample === false ? "Live Preview" : "Email Preview (Mocked)";

const ModalNotificationEmailPreview = ({
  visible,
  setVisible,
  goBack,
  facilityId,
  type = null,
  frequency = null,
  state = null,
  includeTags = false,
  filterChecksheets = false,
  checksheetIds = null,
  watchTags = null
}) => {
  const {
    preview,
    previewLoading,
    previewFailed,
    previewReady,
    previewSubject,
    emptyPreviewKind
  } = useNotificationEmailPreview({
    facilityId,
    type,
    frequency,
    state,
    includeTags,
    filterChecksheets,
    checksheetIds,
    enabled: visible
  });

  return (
    <Modal
      visible={visible}
      setVisible={setVisible}
      goBack={goBack}
      hasBackButton
      maxWidth="1100px"
      width="95%">
      <Heading>{previewHeading(preview)}</Heading>
      <NotificationEmailPreview
        variant="expanded"
        preview={preview}
        previewLoading={previewLoading}
        previewFailed={previewFailed}
        previewReady={previewReady}
        previewSubject={previewSubject}
        emptyPreviewKind={emptyPreviewKind}
        watchType={type}
        watchFilterChecksheets={filterChecksheets}
        watchChecksheets={filterChecksheets ? (checksheetIds || []).map(id => ({id})) : []}
        watchIncludeTags={includeTags}
        watchTags={watchTags || []}
      />
    </Modal>
  );
};

ModalNotificationEmailPreview.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  goBack: PropTypes.func,
  facilityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  type: PropTypes.string,
  frequency: PropTypes.string,
  state: PropTypes.string,
  includeTags: PropTypes.bool,
  filterChecksheets: PropTypes.bool,
  checksheetIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  watchTags: PropTypes.arrayOf(PropTypes.object)
};

export default ModalNotificationEmailPreview;
